export const LOGIN_REQUEST='LOGIN_REQUEST'
export const LOGIN_SUCCESS='LOGIN_SUCCESS'
export const LOGIN_FAILURE='LOGIN_FAILURE'


export const GET_REQUEST='GET_REQUEST'
export const GET_SUCCESS='GET_SUCCESS'
export const GET_FAILURE='GET_FAILURE'